import React from "react";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 py-16">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 flex flex-col md:flex-row md:items-end md:justify-between gap-10">
        <div>
          <span className="font-syne font-extrabold text-3xl tracking-tightest">
            HANCOCK<span className="text-white/40">.</span>
          </span>
          <p className="mt-4 max-w-xs text-white/40 font-light text-sm leading-relaxed">
            Evidence-based online performance coaching. By application only.
          </p>
        </div>
        <div className="flex flex-col md:items-end gap-3 text-xs uppercase tracking-[0.2em] text-white/40">
          <a href="mailto:hancockstraining@gmail.com" className="hover:text-white transition-colors duration-300">hancockstraining@gmail.com</a>
          <span className="text-white/25">© {new Date().getFullYear()} HANCOCK — All rights reserved</span>
        </div>
      </div>
    </footer>
  );
};
